import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateUpdateUserPermissions = {
  updateUserPermissions: { data: null, loading: false, error: null },
};

export const updateUserPermissions = createAsyncThunk('user/updateUserPermissions', async ({ userId, permissions }, { rejectWithValue, fulfillWithValue }) => {
  // permissions = [{name: 'view_employer'}, {name: 'view_vacancy'}, ...]
  return await axiosInstance
    .put(`${process.env.REACT_APP_SERVER_API}/users/${userId}/permissions`, permissions, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUpdateUserPermissions = {
  [updateUserPermissions.pending]: (state) => {
    state.updateUserPermissions.loading = true;
    state.updateUserPermissions.error = null;
  },
  [updateUserPermissions.fulfilled]: (state, action) => {
    state.updateUserPermissions.loading = false;
    state.updateUserPermissions.data = action.payload;
    state.updateUserPermissions.error = null;
  },
  [updateUserPermissions.rejected]: (state, action) => {
    state.updateUserPermissions.loading = false;
    state.updateUserPermissions.error = action.payload;
  },
};
